<template v-if="link_data">
    <router-link
        v-if="link_data.button.is_internal && !link_data.button.whitepaper"
        :to="link_data.button.url"
        :class="['button', {'is-invisible': link_data.config.hide_cta}, {'is-rounded': link_data.config.rounded}, link_data.config.colour, link_data.config.size]"
        :target="link_data.button.open_in_blank ? '_blank' : null"
    >
        {{link_data.button.title}}
    </router-link>
    <a
        v-else-if="!link_data.button.whitepaper"
        :class="['button', {'is-invisible': link_data.config.hide_cta}, {'is-rounded': link_data.config.rounded}, link_data.config.colour, link_data.config.size]"
        :href="link_data.button.url"
        :target="link_data.button.open_in_blank ? '_blank' : null"
    >
        {{link_data.button.title}}
    </a>
    <button
        v-else
        :class="['button', {'is-invisible': link_data.config.hide_cta}, {'is-rounded': link_data.config.rounded}, link_data.config.colour, link_data.config.size]"
        @click.prevent="pop_whitepaper"
    >
        {{link_data.button.title}}
    </button>
</template>

<script>
export default {
    name        :   'CTALink',
    props       :   ['link_data'],
    methods :   {
        pop_whitepaper(e)
        {
            this.$bus.$emit('onWhitepaperRequired', this.link_data.button.whitepaper);
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/blocks/modules/elements/CTALink.vue